import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M21.58,11.13a.51.51,0,0,0-.34-.33.48.48,0,0,0-.46.1,9.11,9.11,0,0,1-2,1.25.24.24,0,0,1-.23,0,.26.26,0,0,1-.13-.2A13.13,13.13,0,0,0,7.76,0a.49.49,0,0,0-.49.21.49.49,0,0,0,0,.53A9.67,9.67,0,0,1,8.5,5.5a9.15,9.15,0,0,1-.63,3.32.25.25,0,0,1-.44,0,8.8,8.8,0,0,1-1-2.29.51.51,0,0,0-.33-.34.5.5,0,0,0-.47.1A9.93,9.93,0,0,0,2,14c0,.18,0,.36,0,.54a10,10,0,1,0,19.57-3.41ZM12,21.25a4,4,0,0,1-4-4.11,7.56,7.56,0,0,1,4.65-6.89.25.25,0,0,1,.29.08.26.26,0,0,1,0,.31,4.31,4.31,0,0,0-.47,4.16.28.28,0,0,0,.18.14.29.29,0,0,0,.22-.06,2.28,2.28,0,0,0,.73-1.06.25.25,0,0,1,.14-.16.22.22,0,0,1,.21,0A3.69,3.69,0,0,1,16,17.25,3.92,3.92,0,0,1,12,21.25Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }